import React, { useState } from "react";
import { Form } from "../components/Form";
import { Feedback } from "../components/Feedback";

const Complaint = () => {
    const [formSubmitted, setFormSubmitted] = useState(false);

    return (
        <>
            <section
                className={`complaint-form__container ${
                    formSubmitted && 'submited'
                }`}>
                <div className='main-container'>
                    {!formSubmitted ? (
                        <FormWrapper setFormSubmitted={setFormSubmitted} />
                    ) : (
                        <Feedback />
                    )}
                </div>
            </section>
        </>
    );
};

const FormWrapper = ({ setFormSubmitted }) => {
    const [loading, setLoading] = useState(false);

    return (
        <>
            <div className='content-wrapper'>
                <h1>Formulario de Denuncia Ley 20.393</h1>
                <p>
                    Este canal se creó con el objetivo de recibir denuncias o
                    sospechas asociados solo a los Delitos involucrados en la
                    Ley 20.393 (Soborno, Lavado de Activos, Receptación,
                    Financiamiento al Terrorismo, Cohecho, Contaminación de
                    Aguas, Apropiación Indebida, Administración Desleal,
                    Negociación Incompatible, Incumplimiento de Normas
                    Sanitarias, Control de Armas, Ley de Migraciones, Delitos
                    Informáticos y cualquier otro delito que se agregue a
                    futuro). Te agradecemos tu compromiso con el cumplimento de
                    las políticas y procedimientos establecidas por Toyota Chile
                    S.A.
                    <br />
                    <br />
                    <span>
                        Todos los campos del formulario son obligatorios.
                    </span>
                </p>
            </div>

            <Form setLoading={setLoading} setFormSubmitted={setFormSubmitted} />

            {loading && (
                <>
                    <div className='bg-overlay'></div>
                    <div className='spinner-container'>
                        <div className='spinner'></div>
                    </div>
                </>
            )}
        </>
    );
};
export default Complaint;
